import React, { useEffect, useState } from 'react';
import axios from 'config/axios';
import { useAppDispatch } from 'hooks/useStore';
import { updateClassroom } from 'store/classroom';
import { setAlert } from 'store/error';
import { Course, Bundle } from 'global/types';

import MyCourses from './MyCourses';
import NewCourses from './NewCourses';
import './index.css';

function Courses() {
    const [tabIndex, setTabIndex] = useState(0);
    const [myCourses, setMyCourses] = useState<Course[]>([]);
    const [newCourses, setNewCourses] = useState<Course[]>([]);
    const [bundles, setBundles] = useState<Bundle[]>([]);

    const dispatch = useAppDispatch();

    useEffect(() => {
        axios.get('courses/')
            .then(res => {
                const {
                    newCourses,
                    myCourses,
                    bundles
                } = res.data;
                setMyCourses(myCourses);
                setNewCourses(newCourses);
                setBundles(bundles);

                if (myCourses.length === 0) setTabIndex(1);

                dispatch(updateClassroom({
                    courses: myCourses
                }));
            })
            .catch(error => {
                dispatch(setAlert(error));
            });
    }, []);

    return (
        <div className='layout'>
            {myCourses.length > 0 && newCourses.length > 0 &&
                <div className='courses__tabs'>
                    <button
                        className={tabIndex === 0 ? 'courses__tab--active' : 'courses__tab'}
                        onClick={() => setTabIndex(0)}
                    >
                        My Courses
                    </button>
                    <button
                        className={tabIndex === 1 ? 'courses__tab--active' : 'courses__tab'}
                        onClick={() => setTabIndex(1)}
                    >
                        Get New Courses
                    </button>
                    <div className={tabIndex === 0
                        ? 'courses__tabIndicatorLeft'
                        : 'courses__tabIndicatorRight'
                    }></div>
                </div>
            }
            {tabIndex === 0
                ?   <MyCourses
                        courses={myCourses}
                    />
                :   <NewCourses
                        courses={newCourses}
                        bundles={bundles}
                    />
            }
        </div>
    );
}

export default Courses;